import * as $ from "jquery";

export const FileMaxSizeRules = (() => {
    const Units = {
        'B' : 1,
        'KB' : 1024,
        'MB' : 1048576
    }
    $.validator.addMethod("fileMaxSize", function (value, element, params) {
        if (params[0] == undefined || params[1] == undefined || Units[params[1]] == undefined){
            return false;
        }
        // @ts-ignore
        if(element.files.length == 0){
            return true;
        }
        let currentMaxSize = Units[params[1]] * params[0];
        // @ts-ignore
        let fileSize = element.files[0].size;
        return currentMaxSize > fileSize
    }, $.validator.format("Wielkość załącznika nie może być większa niż {0} {1}"));
})();import * as $ from "jquery";

export const FileMaxSizeRules = (() => {
    const Units = {
        'B' : 1,
        'KB' : 1024,
        'MB' : 1048576
    }
    $.validator.addMethod("fileMaxSize", function (value, element, params) {
        if (params[0] == undefined || params[1] == undefined || Units[params[1]] == undefined){
            return false;
        }
        // @ts-ignore
        if(element.files.length == 0){
            return true;
        }
        let currentMaxSize = Units[params[1]] * params[0];
        // @ts-ignore
        let fileSize = element.files[0].size;
        return currentMaxSize > fileSize
    }, $.validator.format("Wielkość załącznika nie może być większa niż {0} {1}"));
})();